/**
 * Specific to /tables endpoints
 */
import type { OasTableColumn } from './OasTableColumn';

export const INHERIT_X_WEB_PAGES = 'Inherit x-webPages';

export type DeviceViewAnchorConfig = {
  snField: string;
  hostnameField: string;
};

export type OasTableExtension = {
  columns?: OasTableColumn[];
  webDependencies?: string[];
  deviceViewAnchor?: DeviceViewAnchorConfig;
  /** Markdown description of the table */
  description?: string;
  title?: string;
  webPath?: string;
  /** Indicator for device specific filter options in filters and intent checks */
  deviceFilters: {
    enabled: boolean;
    properties?: string[];
  };
};
/**
 * Specific to endpoints guarded by RBAC
 */
export type OasRbacExtension = {
  apiScopeId?: string;
  disabled?: boolean;
  /**
   * List of ids of system policies endpoint is assigned under.
   * To access this endpoint user needs to have assigned via Roles
   * - one of here listed system policies
   * - or one of custom policies which has assigned this endpoint.
   */
  systemPolicyIds?: string[];
};
export type OasOperationObjectExtension = {
  /**
   * @deprecated from 6.1.0, use x-rbac.apiScopeId
   */
  'x-apiScopeId'?: string;
  'x-rbac'?: OasRbacExtension;
  'x-table'?: OasTableExtension;
  /**
   * Used for defining menus under which endpoint should be listed in UI
   * @example
   * // Endpoint belongs under `Settings > User Management`
   * [['Settings', 'User Management']]
   * @example
   * // Endpoint belongs under `Settings > User management` as well as  `Settings > RBAC`
   * [['Settings', 'User Management'], ['Settings', 'RBAC']]
   */
  'x-tags'?: string[] | typeof INHERIT_X_WEB_PAGES;
};
